export default __webpack_public_path__ + "static/7-01bf804e3d01277743390456c0507242.webp";